import { baseApi } from 'shared/api'
import { io } from 'socket.io-client'
import { customNotify } from 'shared/ui/CustomNotify/customNotify'
import { setMessage } from 'entities/support/model/slice'
import { setOrder, setNewOrder } from 'entities/orders/model/slice'
import { setTransaction } from 'entities/accounts/model/slice'
import { setSymbolQuote } from 'entities/symbols/model/slice'
import { transcformArrayToObject } from 'entities/symbols/helpers/helpers'
import {
  CREATE_TRANSACTION,
  UPD_TRANSACTION,
  SEND_MESSAGE,
  NEW_ORDER,
  UPD_ORDER,
  IS_ACTIVE,
  SYMBOL_CHANEL,
} from './constants'

const SOCKET_HOST = process.env.REACT_APP_WS_URL

const barHandlers: Record<string, (bars: any[]) => void> = {}

export const addBarHandler = (uid: string, fn: (bars: any[]) => void) => {
  barHandlers[uid] = fn
}

export const removeBarHandler = (uid: string) => {
  delete barHandlers[uid]
}

export const wsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    subscribeToEvents: build.query<void, void>({
      queryFn: () => ({ data: undefined }),
      async onCacheEntryAdded(_arg, { dispatch, getState, cacheEntryRemoved }) {
        const token = getState().session.accessToken
        const me = getState().session.me

        const socket = io(SOCKET_HOST, {
          transports: ['websocket'],
          methods: ['GET', 'POST'],
          auth: { headers: { Authorization: `Bearer ${token}` } },
        })

        socket.on('connect', () => {
          if (me?.id) socket.emit(IS_ACTIVE, { id: me.id })
        })

        socket.on(SEND_MESSAGE, event => {
          customNotify(event.data.message, 'message')
          dispatch(setMessage(event.data))
        })
        socket.on(CREATE_TRANSACTION, event => {
          customNotify(event.message, 'deposit')
          dispatch(setTransaction())
        })
        socket.on(UPD_TRANSACTION, event => {
          customNotify(event.message, 'deposit')
          dispatch(setTransaction())
        })
        socket.on(NEW_ORDER, event => {
          dispatch(setNewOrder(event.data))
        })
        socket.on(UPD_ORDER, event => {
          dispatch(setOrder(event.data))
        })
        socket.on(IS_ACTIVE, () => {
          if (me?.id) socket.emit(IS_ACTIVE, { id: me.id })
        })

        socket.on(SYMBOL_CHANEL, (rawBars: any[]) => {
          const preparedBars = rawBars.map(bar => {
            const { t, o, h, l, c, v, cp } = bar
            return {
              ...bar,
              t: +t,
              o: +o,
              h: +h,
              l: +l,
              c: +c,
              v: +v,
              cp: +cp,
            }
          })
          Object.values(barHandlers).forEach(fn => fn(preparedBars))
          const transformed = transcformArrayToObject(preparedBars)
          dispatch(setSymbolQuote(transformed))
        })

        await cacheEntryRemoved
        socket.close()
      },
    }),
  }),
})

export const { useSubscribeToEventsQuery } = wsApi
